module.exports = __webpack_public_path__ + "img/portaventura_banner.30dfa418.jpeg";